import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import {
  Table as TableMaterial,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Box,
  Button,
  withStyles,
  TextField,
  MenuItem,
  FormControl,
  Select,
  IconButton,
} from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';
import orange from '@material-ui/core/colors/orange';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';

import ReceiptIcon from '@material-ui/icons/Receipt';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ReorderIcon from '@material-ui/icons/Reorder';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import EditIcon from '@material-ui/icons/Edit';
import moment from 'moment';
import 'moment/locale/th';
moment().locale('th');

const CheckButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(grey[500]),
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: grey[700],
      color: 'white',
    },
  },
}))(Button);

const PaidButton = withStyles((theme) => ({
  root: {
    color: red[500],
    borderColor: red[500],
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: red[700],
      color: 'white',
    },
  },
}))(Button);

const AnwserButton = withStyles((theme) => ({
  root: {
    color: orange[500],
    borderColor: orange[500],
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: orange[700],
      color: 'white',
    },
  },
}))(Button);

const SuccessButton = withStyles((theme) => ({
  root: {
    color: green[500],
    borderColor: green[500],
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: green[700],
      color: 'white',
    },
  },
}))(Button);

const TableBills = ({ data }) => {
  const [users, setUsers] = useState([]);
  const [fullname, setFullname] = useState('');
  const [dateCreated, setDateCreated] = useState('');
  const [promotion, setPromotion] = useState('');
  const [types, setTypes] = useState([]);

  const converter = (timestamp) => {
    const date = timestamp.toDate();
    const show = moment(new Date(date)).format('DD-MM-YYYY HH:mm');
    return show;
  };

  useEffect(() => {
    const queryData = data.filter(
      (user) =>
        user.fullname.includes(fullname) &&
        converter(user.dateCreated).toString().includes(dateCreated) &&
        user.promotion.includes(promotion) &&
        user.status.includes(types)
    );
    setUsers(queryData);
  }, [data, fullname, dateCreated, promotion, types]);

  const checkStatus = (text) => {
    if (text === 'รอการตรวจสอบ') {
      return (
        <Chip
          size="small"
          label={text}
          style={{ color: 'white', backgroundColor: grey[700], fontSize: 12 }}
        />
      );
    } else if (text === 'ชำระเงินแล้ว') {
      return (
        <Chip
          size="small"
          label={text}
          color="secondary"
          style={{ color: 'white', backgroundColor: red[700], fontSize: 12 }}
        />
      );
    } else if (text === 'มีคำตอบแล้ว') {
      return (
        <Chip
          size="small"
          label={text}
          style={{ color: 'white', backgroundColor: orange[700], fontSize: 12 }}
        />
      );
    } else if (text === 'ส่งคำตอบแล้ว') {
      return (
        <Chip
          size="small"
          label={text}
          style={{ color: 'white', backgroundColor: green[700], fontSize: 12 }}
        />
      );
    }
    return;
  };

  const toggleArray = (item) => {
    let arr = [...types];
    let idx = arr.indexOf(item);
    if (idx !== -1) {
      arr.splice(idx, 1);
    } else {
      arr.push(item);
    }
    setTypes(arr);
  };

  const sumBills = () => {
    let arr = users;

    const promotion1 = arr.filter((user) => user.promotion === 'promotion1')
      .length;
    const promotion2 = arr.filter((user) => user.promotion === 'promotion2')
      .length;

    const sum = promotion1 * 99 + promotion2 * 159;
    return sum;
  };

  return (
    <>
      <Box textAlign="center" pb={2}>
        <CheckButton
          startIcon={<ReceiptIcon />}
          onClick={() => toggleArray('รอการตรวจสอบ')}
          style={
            types.indexOf('รอการตรวจสอบ') === -1
              ? { marginRight: 8 }
              : { background: grey[900], marginRight: 8, color: 'white' }
          }
          variant="outlined"
        >
          รอการตรวจสอบ
        </CheckButton>
        <PaidButton
          startIcon={<AttachMoneyIcon />}
          onClick={() => toggleArray('ชำระเงินแล้ว')}
          style={
            types.indexOf('ชำระเงินแล้ว') === -1
              ? { marginRight: 8 }
              : { background: red[900], marginRight: 8, color: 'white' }
          }
          variant="outlined"
        >
          ชำระเงินแล้ว
        </PaidButton>
        <AnwserButton
          startIcon={<ReorderIcon />}
          onClick={() => toggleArray('มีคำตอบแล้ว')}
          style={
            types.indexOf('มีคำตอบแล้ว') === -1
              ? { marginRight: 8 }
              : { background: orange[900], marginRight: 8, color: 'white' }
          }
          variant="outlined"
        >
          มีคำตอบแล้ว
        </AnwserButton>
        <SuccessButton
          startIcon={<CheckCircleOutlineIcon />}
          onClick={() => toggleArray('ส่งคำตอบแล้ว')}
          style={
            types.indexOf('ส่งคำตอบแล้ว') === -1
              ? { marginRight: 8 }
              : { background: green[900], marginRight: 8, color: 'white' }
          }
          variant="outlined"
        >
          ส่งคำตอบแล้ว
        </SuccessButton>
      </Box>
      <TableContainer component={Paper}>
        <TableMaterial style={{ minWidth: 700 }}>
          <caption>
            <span>สรุปยอดทั้งหมดจากตาราง</span>
            <span style={{ float: 'right' }}>{sumBills()} บาท</span>
          </caption>
          <TableHead>
            <TableRow>
              <TableCell>ชื่อ-สกุล</TableCell>
              <TableCell align="center">สร้างเมื่อ</TableCell>
              <TableCell align="center">โปรโมชั่น</TableCell>
              <TableCell align="center">สถานะ</TableCell>
              <TableCell align="center">จัดการ</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="center">
                <TextField
                  fullWidth
                  value={fullname}
                  onChange={(event) => setFullname(event.target.value)}
                />
              </TableCell>
              <TableCell align="center">
                <TextField
                  fullWidth
                  value={dateCreated}
                  onChange={(event) => setDateCreated(event.target.value)}
                />
              </TableCell>
              <TableCell align="center">
                <FormControl fullWidth>
                  <Select
                    value={promotion}
                    onChange={(event) => setPromotion(event.target.value)}
                  >
                    <MenuItem value="promotion1">3 คำถาม</MenuItem>
                    <MenuItem value="promotion2">5 คำถาม</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell align="center"></TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell component="th" scope="row">
                  {user.fullname}
                </TableCell>
                <TableCell align="center">
                  {converter(user.dateCreated)}
                </TableCell>
                <TableCell align="center">
                  {user.promotion === 'promotion1' ? '3 คำถาม' : '5 คำถาม'}
                </TableCell>
                <TableCell align="center">{checkStatus(user.status)}</TableCell>
                <TableCell align="center">
                  <Link to={`/bills/${user.id}`}>
                    <IconButton aria-label="edit">
                      <EditIcon />
                    </IconButton>
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TableMaterial>
      </TableContainer>
    </>
  );
};

export default TableBills;
